<template>
    <component
        :is="selectedIcon"
        class="Icon"
        :class="{ 'Icon--desktop': desktop }"/>
</template>
<script>
import AntifoulingCan from './assets/AntifoulingCan'
import AntifoulingBucket from './assets/AntifoulingBucket'
import AntifoulingCanHelpWhite from './assets/AntifoulingCanHelpWhite'
import AntifoulingCanHelpBlue from './assets/AntifoulingCanHelpBlue'
import ArrowDown from './assets/ArrowDown'
import ArrowLeft from './assets/ArrowLeft'
import ArrowRight from './assets/ArrowRight'
import CheckMark from './assets/CheckMark'
import Close from './assets/Close'
import Email from './assets/Email'
import FeatureBullet from './assets/FeatureBullet'
import FinKeel from './assets/FinKeel'
import FullKeel from './assets/FullKeel'
import MotorboatFast from './assets/MotorboatFast'
import MotorboatSlow from './assets/MotorboatSlow'
import QuestionMark from './assets/QuestionMark'
import SailingBoat from './assets/SailingBoat'
import Search from './assets/Search'

export default {
    name: 'HempelIcon',
    data() {
        return {
            icons: {
                antifoulingCan: AntifoulingCan,
                antifoulingBucket: AntifoulingBucket,
                antifoulingCanHelpWhite: AntifoulingCanHelpWhite,
                antifoulingCanHelpBlue: AntifoulingCanHelpBlue,
                arrowDown: ArrowDown,
                arrowLeft: ArrowLeft,
                arrowRight: ArrowRight,
                checkMark: CheckMark,
                close: Close,
                email: Email,
                featureBullet: FeatureBullet,
                finKeel: FinKeel,
                fullKeel: FullKeel,
                motorboatFast: MotorboatFast,
                motorboatSlow: MotorboatSlow,
                questionMark: QuestionMark,
                sailingBoat: SailingBoat,
                search: Search
            }
        }
    },
    props: {
        name: {
            type: String,
            required: true
        },
        desktop: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        /**
         * Select icon through computed prop
         * @returns {*}
         */
        selectedIcon() {
            if (this.iconExists(this.name)) {
                return this.icons[this.name]
            }
            throw `Requested undefined icon: ${this.name}`
        }
    },
    methods: {
        /**
         * Check if desired icon name exists
         * @param name
         */
        iconExists(name) {
            return name in this.icons
        }
    }
}
</script>
<style lang="scss">
.Icon {
}
</style>
